<div class="flex justify-center items-center h-screen">
	<div
		class="flex flex-col flex-1 bg-white max-w-5xl w-[60vw] rounded-2xl gap-10 p-16"
	>
		<ui-button
			class="self-start"
			(click)="goToLogin()"
			preset="LOW_EMPHASIS"
			label="Back"
			icon="chevron-left"
		></ui-button>

		<div class="flex flex-col items-start bg-grey-lightest gap-4 p-8">
			<h2>Contact Details</h2>
			<p>For questions and inquiries you can reach us at</p>

			<app-anchor
				url="tel:+{{ supportPhone }}"
				[icon]="ICON.PHONE"
				[external]="true"
				>{{ supportPhone }}</app-anchor
			>
			<app-anchor
				url="mailto:{{ supportEmail }}"
				[icon]="ICON.EMAIL"
				[external]="true"
				>{{ supportEmail }}</app-anchor
			>
		</div>

		<div class="self-center">
			<img
				src="assets/images/auth/undraw-contact-us.webp"
				alt="Contact Us Image"
			/>
		</div>
	</div>
</div>
